import React, { useState } from 'react';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { AnimatePresence } from 'framer-motion';
import { FadeSlideMotionBox } from '../../../components/Motion/FadeSlideMotionBox';
import { capitalize } from '../../../helpers/string';
import { Icon, List } from '@chakra-ui/react';
import { ListItem } from '../../../components/UI-CHAKRA/ListItem';
import { ReactComponent as Pills } from '../../../assets/images/icons/mevo/exam/ic-pills.svg';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';

interface SummaryAcoordionProps {
  title: string;
  body: Array<string>;
}

export default function SummaryAccordion(props: SummaryAcoordionProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box padding={'14px 16px'} borderRadius={'10px'} bg={'#fff'}>
      <Button
        variant={'ghost'}
        onClick={handleToggle}
        p={0}
        m={0}
        w={'100%'}
        h={'100%'}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        fontSize={'12px'}
        fontWeight={600}
        lineHeight={'12px'}
      >
        <Flex gap={'5px'} alignItems={'center'} justifyContent={'center'}>
          <Pills />
          {props.title}
        </Flex>
        <Icon as={isOpen ? MdExpandLess : MdExpandMore} fontSize={'20px'} color={'#ADB5BD'} />
      </Button>
      <AnimatePresence>
        {isOpen && (
          <Box mt={'5px'} overflow={'hidden'}>
            <FadeSlideMotionBox>
              <List spacing={1} styleType="none">
                {props.body.map((val, index) => (
                  <ListItem key={index} position="relative" pl={4}>
                    <Text
                      fontSize={'8px'}
                      fontWeight={400}
                      lineHeight={'11px'}
                      position="absolute"
                      left={0}
                      top={0}
                      color="#7B55AA"
                    >
                      ●
                    </Text>
                    <Text fontSize={'10px'} fontWeight={400} lineHeight={'11px'}>
                      {capitalize(val)}
                    </Text>
                  </ListItem>
                ))}
              </List>
            </FadeSlideMotionBox>
          </Box>
        )}
      </AnimatePresence>
    </Box>
  );
}
